import React from "react";
import LocationSelector from "./components/LocationSelector";
import "./index.css";

function App() {
  return (
    <div className="App">
      <LocationSelector />
    </div>
  );
}

export default App;
